export default "__VITE_ASSET__BXTbLGI2__"